import React from 'react';
import PropTypes from 'prop-types';
import FieldLinks from '@piconetworks/pkg-field-link';
import styles from './Links.module.scss.js';

var LinksPreview = function LinksPreview(_ref) {
  var linkBlock = _ref.linkBlock,
    _ref$richMediaUrls = _ref.richMediaUrls,
    richMediaUrls = _ref$richMediaUrls === void 0 ? {} : _ref$richMediaUrls;
  var renderLinkPreviews = React.useCallback(function () {
    return /*#__PURE__*/React.createElement(FieldLinks, {
      linkBlocks: [linkBlock],
      linkBlockClassName: "block",
      name: "linkBlocks",
      richMediaData: richMediaUrls
    });
  }, [linkBlock]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.linksPreview_container
  }, renderLinkPreviews());
};
LinksPreview.propTypes = {
  linkBlock: PropTypes.object,
  richMediaUrls: PropTypes.object
};
var LinksPreview$1 = /*#__PURE__*/React.memo(LinksPreview);

export { LinksPreview$1 as default };
//# sourceMappingURL=index.js.map
